import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f4ea07e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/img/login/cover-img.jpg",
    alt: "Nicely Done"
  })
], -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "heading-container" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "heading" }, "Sign In", -1))
const _hoisted_7 = {
  key: 0,
  class: "button"
}
const _hoisted_8 = { href: "/register" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "forgot" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "/password" }, "Forgot Password")
], -1))
const _hoisted_10 = {
  key: 1,
  class: "or"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "or-text" }, "or", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_14 = [
  _hoisted_11,
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "oauth-icon",
  src: "/img/login/google-oauth-icon.svg"
}, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "oauth-icon",
  src: "/img/login/okta-oauth-icon.png"
}, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "oauth-icon",
  src: "/img/login/microsoft-oauth-icon.png"
}, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "heading" }, "Enter Multi-Factor Code", -1))
const _hoisted_19 = { class: "error" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "forgot" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "/password" }, "Forgot Password")
], -1))
const _hoisted_21 = { class: "lost-access-legend" }
const _hoisted_22 = { class: "error" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ask-logo" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.asknicely.com",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/img/asknicely_logo_grey.svg",
      alt: "AskNicely"
    })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MFASetupOk = _resolveComponent("MFASetupOk")!
  const _component_MFASetup = _resolveComponent("MFASetup")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_Input = _resolveComponent("Input")!
  const _component_GrecaptchaBox = _resolveComponent("GrecaptchaBox")!
  const _component_MFAVerifyRecoveryCode = _resolveComponent("MFAVerifyRecoveryCode")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_CredentialsForm = _resolveComponent("CredentialsForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: "login-form",
      onKeyup: _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["enter"]))
    }, [
      _createVNode(_component_CredentialsForm, {
        logo: _ctx.loginData.logo
      }, {
        default: _withCtx(() => [
          (_ctx.mfaEnforce)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.mfaSuccess)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_component_MFASetupOk, {
                        "is-loading": _ctx.isLoading,
                        codes: _ctx.recoveryCodes,
                        "from-mfa-setup": true,
                        onOnDone: _ctx.onDone,
                        onOnDownload: _ctx.onDownloadRecoveryCodes
                      }, null, 8, ["is-loading", "codes", "onOnDone", "onOnDownload"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createVNode(_component_MFASetup, {
                        email: _ctx.email,
                        password: _ctx.password,
                        "qr-url": _ctx.mfaQrCode,
                        "mfa-secret": _ctx.mfaSecret,
                        onMfaUpdate: _ctx.mfaValidateLogin,
                        onMfaCancel: _ctx.mfaCancel
                      }, null, 8, ["email", "password", "qr-url", "mfa-secret", "onMfaUpdate", "onMfaCancel"])
                    ]))
              ], 64))
            : (!_ctx.mfaLogin)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.loginData.emailLoginEnabled)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_5, [
                          _hoisted_6,
                          (_ctx.loginData.canSelfRegister)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                _createElementVNode("a", _hoisted_8, [
                                  _createVNode(_component_BaseButton, {
                                    white: "",
                                    bordered: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Register")
                                    ], undefined, true),
                                    _: 1
                                  })
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode(_component_Input, {
                          ref: "email",
                          modelValue: _ctx.email,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                          title: "Email",
                          placeholder: "Email",
                          regex: /.+@.+\..+/,
                          required: true,
                          "err-msg": 'Valid email is required'
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_Input, {
                          ref: "password",
                          modelValue: _ctx.password,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                          title: "Password",
                          placeholder: "Password",
                          type: "password",
                          required: true,
                          "err-msg": 'Invalid Password'
                        }, null, 8, ["modelValue"]),
                        (_ctx.loginData.hasRecaptcha)
                          ? (_openBlock(), _createBlock(_component_GrecaptchaBox, {
                              key: 0,
                              ref: "grecaptcha",
                              sitekey: _ctx.loginData.recaptcha
                            }, null, 8, ["sitekey"]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_BaseButton, {
                          class: "sign-in-button",
                          "new-primary": "",
                          full: "",
                          large: "",
                          click: _ctx.login
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Sign In")
                          ], undefined, true),
                          _: 1
                        }, 8, ["click"]),
                        _hoisted_9
                      ], 64))
                    : _createCommentVNode("", true),
                  (
                            _ctx.loginData.emailLoginEnabled &&
                            _ctx.loginData.hasOauthLogins
                        )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_14))
                    : _createCommentVNode("", true),
                  (_ctx.loginData.googleUrl)
                    ? (_openBlock(), _createBlock(_component_BaseButton, {
                        key: 2,
                        click: () => _ctx.redirectTo(_ctx.loginData.googleUrl),
                        class: "sign-in-button",
                        secondary: "",
                        bordered: "",
                        full: "",
                        large: ""
                      }, {
                        default: _withCtx(() => [
                          _hoisted_15,
                          _createTextVNode(" Sign in with Google ")
                        ], undefined, true),
                        _: 1
                      }, 8, ["click"]))
                    : _createCommentVNode("", true),
                  (_ctx.loginData.oktaUrl)
                    ? (_openBlock(), _createBlock(_component_BaseButton, {
                        key: 3,
                        click: () => _ctx.redirectTo(_ctx.loginData.oktaUrl),
                        class: "sign-in-button",
                        secondary: "",
                        bordered: "",
                        full: "",
                        large: ""
                      }, {
                        default: _withCtx(() => [
                          _hoisted_16,
                          _createTextVNode(" Sign in with Okta ")
                        ], undefined, true),
                        _: 1
                      }, 8, ["click"]))
                    : _createCommentVNode("", true),
                  (_ctx.loginData.microsoftUrl)
                    ? (_openBlock(), _createBlock(_component_BaseButton, {
                        key: 4,
                        click: () => _ctx.redirectTo(_ctx.loginData.microsoftUrl),
                        class: "sign-in-button",
                        secondary: "",
                        bordered: "",
                        full: "",
                        large: ""
                      }, {
                        default: _withCtx(() => [
                          _hoisted_17,
                          _createTextVNode(" Sign in with Microsoft 365 ")
                        ], undefined, true),
                        _: 1
                      }, 8, ["click"]))
                    : _createCommentVNode("", true),
                  (_ctx.loginData.samlSsoUrl)
                    ? (_openBlock(), _createBlock(_component_BaseButton, {
                        key: 5,
                        click: () => _ctx.redirectTo(_ctx.loginData.samlSsoUrl),
                        class: "sign-in-button",
                        "new-primary": "",
                        full: "",
                        large: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.loginData.samlSsoName), 1)
                        ], undefined, true),
                        _: 1
                      }, 8, ["click"]))
                    : _createCommentVNode("", true)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  (_ctx.mfaSuccess && _ctx.recoveryCodes)
                    ? (_openBlock(), _createBlock(_component_MFASetupOk, {
                        key: 0,
                        "is-loading": _ctx.isLoading,
                        codes: _ctx.recoveryCodes,
                        "from-mfa-setup": false,
                        onOnDone: _ctx.onDone,
                        onOnDownload: _ctx.onDownloadRecoveryCodes
                      }, null, 8, ["is-loading", "codes", "onOnDone", "onOnDownload"]))
                    : (_ctx.isMfaRecoveryPage)
                      ? (_openBlock(), _createBlock(_component_MFAVerifyRecoveryCode, {
                          key: 1,
                          onOnBack: _ctx.mfaCancel,
                          onOnSubmit: _ctx.onVerifyRecoveryCode
                        }, null, 8, ["onOnBack", "onOnSubmit"]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _hoisted_18,
                          _createVNode(_component_Input, {
                            ref: "mfa",
                            modelValue: _ctx.mfa,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.mfa) = $event)),
                            title: "Multi-Factor Authentication Code",
                            type: "number",
                            placeholder: "6 digit MFA code",
                            required: true,
                            "err-msg": 'Code cannot be empty'
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_Checkbox, {
                            class: "remember-device-checkbox",
                            checked: _ctx.mfaRememberDevice,
                            onChange: _ctx.onChangeRememberDevice
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Remember this device for 30 days")
                            ], undefined, true),
                            _: 1
                          }, 8, ["checked", "onChange"]),
                          _createVNode(_component_BaseButton, {
                            class: "sign-in-button",
                            "new-primary": "",
                            full: "",
                            large: "",
                            click: _ctx.login
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Sign In")
                            ], undefined, true),
                            _: 1
                          }, 8, ["click"]),
                          _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.error), 1),
                          _hoisted_20,
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("a", {
                              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onLostAuthenticatorLink && _ctx.onLostAuthenticatorLink(...args)))
                            }, "Lost Access To My Authenticator")
                          ])
                        ], 64))
                ], 64)),
          _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.error), 1),
          _hoisted_23
        ], undefined, true),
        _: 1
      }, 8, ["logo"])
    ], 32)
  ]))
}